module.exports = "<div [hidden]=\"Skeleton.Hidden\">\r\n  <button\r\n    [disabled]=\"Skeleton.Disable\"\r\n    class=\"btn btn-icon btn-default\"\r\n    (click)=\"OnClick()\"\r\n  >\r\n    <i\r\n      [hidden]=\"!Skeleton.IconCss\"\r\n      [ngClass]=\"'fa fa-' + (Skeleton.IconCss || '')\"\r\n    ></i>\r\n    {{ Skeleton.Label }}\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/s-button/s-button.component.html
// module id = ./src/app/shared/components/s-button/s-button.component.html
// module chunks = main